import { useContext } from 'react';
import { MobxContext } from "@/store";


function useMobx(storeName?: 'store' | 'operate') {
  const rootStore: any = useContext(MobxContext)
  return storeName ? rootStore[storeName] : rootStore;
}

export {
  useMobx
}
